
import { CreateElement, RenderContext, FunctionalComponentOptions } from 'vue'
import * as T from '@/types'

import { UiButton } from '@hubsolv/hubsolv-ui'

const logo = require('@/assets/creditordesk-logo-light.svg')
const smallLogo = require('@/assets/cd-logo-green.svg')

const AppLogo: FunctionalComponentOptions = {
    functional: true,

    props: {
        light: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    render (h: CreateElement, context: RenderContext<any>) {
        const logoImg = <img class='logo large' src={logo} alt='CreditorDesk logo'/>
        const smallLogoImg = <img class='logo small' src={smallLogo} alt='CreditorDesk logo'/>
        return (
            <router-link class='app-logo-container' to={{ name: T.CrmRoute.ACCOUNT_HOME }}>
                <div class='app-logo'>
                    {!context.props.small ? logoImg : smallLogoImg}
                    {!context.props.small && <div class='badge' role='presentational'>alpha</div>}
                </div>
            </router-link>
        )
    },
}

export default AppLogo
